import { Box } from "@mui/material";
import WorkSpaceItemListFileComponentImage from "../../../../../../../../../WorkSpaceItem/WorkSpaceItemListFileComponentImage";
import { WorkSpaceUserName } from "../../../../../../../../../../model/ItemModel";

interface IDocumentDetailMetaDataInformationImage
{
    workItem: WorkSpaceUserName;
}

export default function DocumentDetailMetaDataInformationImage({
    workItem
}: IDocumentDetailMetaDataInformationImage)
{
    return (
        <Box>
            <WorkSpaceItemListFileComponentImage boxLayout={false} widthIcon="30px"
                extension={workItem?.extension}
            />
        </Box>
    )
}